/**
 * ChitauriArtificier.js
 * The Chitauri Artificier Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";
import { EnemyParticle } from "../game/particles/EnemyParticle";

export class ChitauriArtificier extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);
        const probCharging = Game.utils.assertNumber(enemyData.ProbCharging, 1);

        /** @private @type {Boolean} */
        this._isCharging = false;

        // Ability choices
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, probAddRandom);
        this._abilityChoices.addChoice(EnemyAbilities.eCHARGE_UP, probCharging);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM:
                let addBubbleData = {
                    nbBubbles: this._nbBubblesAdd,
                    color: BubbleColor.eRANDOM,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleData);
                break;
            case EnemyAbilities.eCHARGE_UP:
                this._isCharging = true;
                Game.fire(GameEvents.eGAME_ABILITY_ENEMY_POWER_UP, this);
                this._chooseNextAction();
                break;
            default:
                console.error("[ChitauriArtificier._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }

    /**
     * The attack particle has reached its target
     * @protected
     * @override
     * @param {EnemyParticle} particle
     */
    _onDamageParticleCompleted(particle) {
        if (this._isCharging) {
            const chargedDamage = this._attackDamage * (this._chargingDamageBonus / 100);
            Game.fire(GameEvents.eHEROES_HIT, chargedDamage, particle);
            Game.fire(GameEvents.eGAME_ABILITY_ENEMY_POWER_DOWN, this);
            this._isCharging = false;
        } else {
            Game.fire(GameEvents.eHEROES_HIT, this._attackDamage, particle);
        }

        this._chooseNextAction();
    }
}
